module.exports = __webpack_public_path__ + "img/20190705163644QQ截图20190705091105.079fa0b4.png";